var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboardSidebarRoles(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 18.5,
    r: 18.5,
    fill: "#322C3E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5055:28648)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9999 9L21.0862 10.08L23.4087 10.4325L24.4612 12.5325L26.1324 14.1825L25.7499 16.5L26.1324 18.8175L24.4612 20.4675L23.4087 22.5675L21.0862 22.92L18.9999 24L16.9137 22.92L14.5912 22.5675L13.5387 20.4675L11.8674 18.8175L12.2499 16.5L11.8674 14.1825L13.5387 12.5325L14.5912 10.4325L16.9137 10.08L18.9999 9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 23.7424V28.9999L19 27.7499L24 28.9999V23.7424L21.4775 24.1249L19 25.4074L16.5225 24.1249L14 23.7424Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5055:28648"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(9 9)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardSidebarRoles);
export default __webpack_public_path__ + "static/media/dashboard-sidebar-roles.e464605dc0f5ff8acb27798aaa91d8a0.svg";
export { ForwardRef as ReactComponent };